class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverQuery = window.matchMedia('(min-width: 1080px) and (hover: hover)');
    this.onMediaChange = this.onMediaChange.bind(this);
    this.boundMainEnter = this.onMainMouseEnter.bind(this);
    this.boundMainLeave = this.onMainMouseLeave.bind(this);
    this.boundSummaryClick = this.onSummaryClick.bind(this);
    this.nestedCleanups = [];
  }

  connectedCallback() {
    this.hoverQuery.addEventListener('change', this.onMediaChange);
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.boundSummaryClick);
    this.syncHoverListeners();
  }

  disconnectedCallback() {
    this.hoverQuery.removeEventListener('change', this.onMediaChange);
    this.disableHoverBehavior();
    const summary = this.mainDetailsToggle?.querySelector('summary');
    if (summary) summary.removeEventListener('click', this.boundSummaryClick);
  }

  onSummaryClick(e) {
    if (!this.hoverQuery.matches) return;
    if (e.target.closest('a.mega-menu__level1-link')) return;
    if (this.mainDetailsToggle.hasAttribute('open')) {
      e.preventDefault();
    }
  }

  syncHoverListeners() {
    if (this.hoverQuery.matches) {
      this.enableHoverBehavior();
    } else {
      this.disableHoverBehavior();
    }
  }

  onMediaChange() {
    this.syncHoverListeners();
  }

  enableHoverBehavior() {
    if (this._hoverBehaviorEnabled) return;
    this._hoverBehaviorEnabled = true;
    this.addEventListener('mouseenter', this.boundMainEnter);
    this.addEventListener('mouseleave', this.boundMainLeave);
    this.initNestedHover();
  }

  disableHoverBehavior() {
    if (!this._hoverBehaviorEnabled) return;
    this._hoverBehaviorEnabled = false;
    this.removeEventListener('mouseenter', this.boundMainEnter);
    this.removeEventListener('mouseleave', this.boundMainLeave);
    this.teardownNestedHover();
    this.closeNestedDetails();
    this.close();
  }

  onMainMouseEnter() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  onMainMouseLeave() {
    this.close();
    this.closeNestedDetails();
  }

  closeNestedDetails() {
    this.querySelectorAll('.header__submenu details[open]').forEach((d) => {
      d.removeAttribute('open');
      const s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  initNestedHover() {
    this.querySelectorAll('.header__submenu > li').forEach((li) => {
      const nested = li.querySelector(':scope > details');
      if (!nested) return;
      const enter = () => {
        if (this.hoverQuery.matches) nested.setAttribute('open', '');
      };
      const leave = () => {
        if (this.hoverQuery.matches) nested.removeAttribute('open');
      };
      li.addEventListener('mouseenter', enter);
      li.addEventListener('mouseleave', leave);
      this.nestedCleanups.push(() => {
        li.removeEventListener('mouseenter', enter);
        li.removeEventListener('mouseleave', leave);
      });
    });
  }

  teardownNestedHover() {
    this.nestedCleanups.forEach((fn) => fn());
    this.nestedCleanups = [];
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
